import { axios } from '@Root/API'

export const get = (studyProgrammeId, courseReferenceId) => {
	return axios.get(`program/${studyProgrammeId}/course-reference/${courseReferenceId}`)
}
